<template>
<section class="top-container" :class="{'search-box': openSearch}" style="min-width:1312px;">
  <div class="top-wrap">
    <div class="w1312 top-content main-content-wrap clearfix">
      <div class="left-container clearfix">
        <a class="header-logo" href="#/">
          <img :src="headerLogo" width="136" height="20"/>
        </a>
        <ul>
          <li>
            {{getSessionTargetLabel}}
            <i class="arrow-icon"></i>
            <dl class="version">
              <dd v-for="(item, index) in versions" :key="index" @click="toggleVersion(item.value)" :class="{'hover': item.value === sessionTarget}" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '切换版本' })">{{item.label}}</dd>
            </dl>
          </li>
          <li>
            <a href="http://www.vip.com" target="_blank" title="唯品会首页" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '唯品会首页' })">唯品会首页</a>
          </li>    
        </ul>
      </div>
      <div class="right-container">
        <span v-if="userInfo.username">
          <div style="display: inline-block; width:18px; height: 18px; border-radius: 18px; overflow: hidden; position: relative; top:3px;" v-if="userInfo.avatarUrl">
            <imgWrap :src="userInfo.avatarUrl" width="18" height="18" :alt="userInfo.username" :item="userInfo" :pic="'avatarUrl'"/>
          </div>
          {{userInfo.username}}
          |
          <a href="javascript:;" @click="loginOut()">退出</a>
        </span>
        <span v-else>
          <a :href="`https://passport.vip.com/login?src=${locationHref}`" @click="goLogin()" title="请登录">
            <i class="header-user"></i> 请登录
          </a> |
          <a href="https://passport.vip.com/register" title="注册">注册</a>
        </span>
      </div>
    </div>
    <div class="w1312 search-container clearfix" v-if="!openSearch">
      <div class="header-logo2"></div>
      <div class="fly-pic"></div>
      <div class="search-content" v-if="enabledSearch">
        <div class="search-box">
          <input placeholder="请输入内容" v-model="keywords" @focus="handleFocus" @blur="handleBlur" @input="handleInput" @keyup.enter="goSearch()" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '搜索' })"/>
          <button class="search-button" @click="goSearch()" mars_sead="vschool_searchlanding_searchbox_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})"></button>
          <template v-if="!suggesterHide && !!suggesterList.length">
            <ul class="list">
              <li v-for="(item, index) in suggesterList" :key="index">
                <!-- <a href="javascript:;" @click.stop="goTo(item)">
                  <span v-html="item.title"></span>
                </a> -->
                <router-link :to="{ name: 'CourseDetail', params: {target: sessionTarget, courseId: item.courseId}}" target="_blank" mars_sead="vschool_searchlanding_searchbox_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})">
                  <span v-html="item.title"></span>
                </router-link>
                <!-- <router-link :to="{ name: 'CourseDetail', params: {target: sessionTarget, courseId: item.courseId}}"> -->
                <!-- </router-link> -->
              </li>
            </ul>
          </template>
        </div>
        <p>
          <!-- <a href="javascript:;" :title="item.keyword" v-for="(item, index) in hotKeywords" :key="index">{{item.keyword}}</a> -->
          <router-link :to="{'name': 'Search', params: {target: sessionTarget}, query: {'keywords': item.keyword}}" :title="item.keyword" v-for="(item, index) in hotKeywords" :key="index" target="_blank" mars_sead="vschool_searchlanding_searchpopularview_buttonclick">{{item.keyword}}</router-link>
        </p>
      </div>
    </div>
    <div class="w1312 nav-container" :class="{'hide': highLightNav === 'NoticeInfo'}" v-if="!openSearch">
      <ul>
        <li :class="{'active': ['Index', 'TargetIndex'].includes(highLightNav)}">
          <a href="#/" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '首页' })">首页</a>
        </li>
        <li>
          <a :href="`https://rule.vip.com/#/rule?categoryId=${sessionTarget === 2 ? 3 : 4}`" target="_blank" title="平台规则中心" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '规则中心' })">规则中心</a>
        </li>
        <li :class="{'active': highLightNav === 'Course'}">
          <router-link :to="{ name: 'Course', params: {target: sessionTarget}}" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '课程中心' })">课程中心</router-link>
        </li>
        <li :class="{'active': highLightNav === 'ExamCenter'}">
          <router-link :to="{ name: 'ExamCenter', params: {target: sessionTarget}}" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '考试中心' })">
            考试中心
          </router-link>
        </li>
        <li :class="{'active': highLightNav === 'UserCenter'}">
          <router-link :to="{ name: 'UserCenter', params: {target: sessionTarget}}" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '个人中心' })">
            个人中心
          </router-link>
        </li>
      </ul>
    </div>
    <div class="w1312 search-container-l" v-if="openSearch">
      <div class="search-content">
        <div class="search-box">
          <input placeholder="请输入内容" v-model="keywords" @focus="handleFocus" @blur="handleBlur" @input="handleInput" @keyup.enter="goSearch(true)" mars_sead="vschool_all_frame__buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget, 'buttonclick state': '搜索' })"/>
          <button class="search-button" @click="goSearch(true)" mars_sead="vschool_searchlanding_searchbox_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})"></button>
          <template v-if="!suggesterHide && !!suggesterList.length">
            <ul class="list">
              <li v-for="(item, index) in suggesterList" :key="index">
                <a href="javascript:;" @click.stop="goTo(item)" mars_sead="vschool_searchlanding_searchbox_buttonclick" :data-vis-mvar="JSON.stringify({'sessionTarget': sessionTarget})">
                  <span v-html="item.title"></span>
                </a>
                <!-- <router-link :to="{ name: 'CourseDetail', params: {target: sessionTarget, courseId: item.courseId}}"> -->
                <!-- </router-link> -->
              </li>
            </ul>
          </template>
        </div>
      </div>
    </div>
  </div>

</section>
</template>

<script>
import {
  setCookie
} from '@/lib/index.js'
import {watch} from 'vue'
import {useRouter} from 'vue-router'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import {clearCookies} from '@/lib'
import headerLogo from '../assets/img/header-top-logo.png'
import headerUser from '../assets/img/header-user.png'
import imgWrap from '@/components/imgWrap'
import util from '../util/index'
import watermarkDom from '@/lib/watermark-dom'
import '@/lib/watermark.js'
export default {
  name: '',
  data () {
    return {
      locationHref: encodeURIComponent(window.location.href),
      headerLogo,
      headerUser,
      highLightNav: 'Index',
      keywords: '',
      suggesterHide: true
    }
  },
  computed: {
    ...mapState(['sessionTarget', 'userInfo', 'versions', 'categoryList', 'primaryCategoryId', 'queryUserPromise']),
    ...mapState('search', ['suggesterList', 'openSearch', 'enabledSearch', 'hotKeywords']),
    ...mapGetters(['getSessionTargetLabel'])
  },
  beforeMount () {
    let target = window.location.hash.substr(2,1)
    target = Number(target)
    let sessionTarget = window.localStorage.getItem('sessionTarget')
    sessionTarget = Number(sessionTarget)
    this.goQueryUser({
      target,
      sessionTarget
    })
    clearTimeout(window.timer)
  },
  beforeCreate () {
    setCookie('school_login_type', window.sessionStorage.getItem('school_login_type'), 8 * 1000, 'vip.com')
  },
  mounted () {
    const router = useRouter()
    this.queryUserPromise.then(() => {
      this.refreshCache()
      this.searchEnabled()
      this.queryCategoryTree()
      this.getHotKeywords(5)
      this.togglePage(router.currentRoute.value)
      watermarkDom.load({
        watermark_txt: this.userInfo.uid ? `${this.userInfo?.username || '唯品会会员'}\n${this.userInfo.uid}` : '唯品会保密信息，\n未经允许不得扩散'
      })
      watch(
        () => router.currentRoute.value,
        (newVal) => {
          this.togglePage(newVal)
        },
        { immediate: false }
      )
    })
  },
  filters: {
  },
  methods: {
    goLogin () {
      setCookie('school_login_type', '2', 8 * 1000, 'vip.com')
      window.sessionStorage.setItem('school_login_type', '2')
    },
    refreshCache () {
      clearTimeout(window.timer)
      window.timer = setTimeout(() => {
        setCookie('school_login_type', window.sessionStorage.getItem('school_login_type'), 8 * 1000, 'vip.com')
        this.refreshCache()
      }, 5000)
    },
    goTo (item) {
      this.$router.push({
        name: 'CourseDetail',
        params: {
          target: this.sessionTarget,
          courseId: item.courseId
        }
      })
      setTimeout(() => {
        this.keywords = ''
        this.updateCompletionSuggester()
      }, 200)
    },
    goSearch (self) {
      if (!this.keywords || !this.keywords.trim()) {
        return this.$message.warning('请输入要查询的关键字')
      }
      if (self) {
        this.$router.push({
          name: 'Search',
          params: {
            target: this.sessionTarget
          },
          query: {
            keywords: this.keywords
          }
        })
        return
      }
      let routeData = this.$router.resolve({
        name: 'Search',
        params: {
          target: this.sessionTarget
        },
        query: {
          keywords: this.keywords
        }
      })
      window.open(routeData.href, '_blank')
    },
    handleFocus () {
      this.suggesterHide = false
    },
    handleBlur () {
      setTimeout(() => {
        this.suggesterHide = true
      }, 200)
    },
    building () {
      this.$message.warning('模块建设中，请耐心等待')
    },
    handleInput () {
      if (!this.keywords || !this.keywords.trim()) {
        this.updateCompletionSuggester()
        return
      }
      this.getCompletionSuggester(this.keywords).then((resp) => {
        console.log(resp)
      }).catch((resp) => {
        console.log(resp)
      })
    },
    ...mapMutations(['updatePrimaryCategoryId', 'updateCategory']),
    ...mapMutations('search', ['updateCompletionSuggester']),
    ...mapActions('search', ['getHotKeywords', 'getCompletionSuggester', 'searchEnabled']),
    toggleVersion (val) {
      let sessionTarget = window.localStorage.getItem('sessionTarget')
      this.updateSessionTarget(val)
      if (sessionTarget && Number(sessionTarget) === val) {
        return
      }
      this.updateCategory()
      if (['UserCenter'].includes(this.$route.name) ) {
        this.$router.push({
          name: this.$route.name,
          params: {
            target: val
          }
        })
      } else {
        this.$router.push({
          name: 'TargetIndex',
          params: {
            target: val
          }
        })
        this.queryCategoryTree()
      }
    },
    ...mapMutations(['updateSessionTarget']),
    ...mapActions(['queryCategoryTree', 'goQueryUser', 'signout']),
    loginOut () {
      this.signout().then(() => {
        clearCookies()
        setCookie('school_login_type', '2', 8 * 1000, 'vip.com')
        window.sessionStorage.setItem('school_login_type', '2')
        let src = `https://passport.vip.com/login?src=${window.encodeURIComponent(window.location.href)}`
        window.location.href = src
      })
    },
    togglePage (newVal) {
      const {
        keywords
      } = this.$route.query
      this.keywords = keywords || ''
      this.updatePrimaryCategoryId(0)
      // 埋点信息
      let marsMap = {
        'Index': 'page_shouyepeizhi',
        'TargetIndex': 'page_shouyepeizhi',
        'UserCenter': 'page_gerenzhongxin',
        'Course': 'page_course_center',
        'NoticeInfo': 'page_shouyepeizhi_noticelanding',
        'NoticeList': 'page_noticelist',
        'Search': 'page_searchlanding',
        'CourseDetail': 'page_courselanding'
      }
      if (marsMap[newVal.name]) {
        util.Mars.send(marsMap[newVal.name], {'sessionTarget': this.sessionTarget, 'categoryId': newVal.params.menuCategory || undefined})
      }
      {
        if (newVal.name === 'UserCenter' && (!this.userInfo || !this.userInfo.username)) {
          window.location.href = `https://passport.vip.com/login?src=${this.locationHref}`
        }
        // console.log('currentRoute', newVal)
        this.highLightNav = newVal.name
      }
    }
  },
  components: {
    imgWrap
  }
}
</script>

<style lang="scss" scoped>
.top-container {
  background: url(../assets/img/bg-banner.png) center top;
  background-size: 100% 273px;
  background-repeat: no-repeat;
  min-height: 273px;
  line-height: 30px;
  .top-wrap {
    background: url(../assets/img/bg-mask.png) center top no-repeat;
  }
  .top-content  {
    padding-top: 20px;
    color: #fff;
    font-size: 12px;
    a {
      color: #fff;
    }
    .left-container {
      float: left;
      .header-logo {
        float: left;
      }
      ul {
        float: left;
        margin-left: 40px;
        display: inline-block;
        position: relative;
        top: -3px;
        z-index: 3;
        li {
          float: left;
          margin-right: 20px;
          display: inline-block;
          position: relative;
          &:first-child {
            width: 62px;
          }
          dl {
            position: absolute;
            border-radius: 6px;
            border: 1px solid #fff;
            display: none;
            min-width: 84px;
            top: 30px;
            left: -5px;
            background: #fff;
            color: #333;
            overflow: hidden;
            padding: 6px;
            font-size: 14px;
            dt, dd {
              cursor: pointer;
              padding-left: 5px;
              padding-right: 5px;
            }
            dd {
              // display: none;
              border-radius: 3px;
              margin-top: 1px;
            }
            dd.hover {
              background: #F3F5F7;
            }
            dd:hover {
              color: #FD3374;
            }
          }
          &.version.hover, &:hover {
            dl {
              border: 1px solid #fff;
              display: block;
            }
            dd {
              display: block;
            }
            .arrow-icon {
              transform: rotate(-180deg);
              -webkit-transform: rotate(-180deg);
              top: 7px;
            }
          }
        }
        .arrow-icon {
          width: 0;
          height: 0;
          font-size: 0;
          line-height: 0;
          overflow: hidden;
          border-width: 5px;
          border-style: solid;
          border-color: #fff transparent transparent transparent;
          margin-left: 5px;
          position: absolute;
          transition: all;
          transform: rotate(0deg) 0.5s;
          top: 14px;
        }
      }
    }
    .right-container {
      float: right;
      a {
        margin-right: 5px;
        margin-left: 5px;
      }
      .header-user {
        background: url(../assets/img/header-user.png);
        background-repeat: no-repeat;
        display: inline-block;
        width: 18px;
        height: 18px;
        position: relative;
        top: 3px;
      }
    }
  }
  .search-container {
    .header-logo2 {
      float: left;
      background: url(../assets/img/header-logo.png);
      background-repeat: no-repeat;
      width:360px;
      min-height: 100px;
      margin-top: 32px;
      margin-left: 95px;
    }
    .search-content {
      float: right;
      margin-top: 65px;
      .search-box {
        background: url(../assets/img/search-bg.png);
        background-repeat: no-repeat;
        width: 335px;
        height: 40px;
        position: relative;
        z-index: 2;
        input {
          line-height: 40px;
          height: 40px;
          vertical-align: top;
          background: none;
          border: none;
          padding-left: 18px;
          color: #fff;
          font-size: 14px;
          width: 276px;
          outline: none;
          &::-webkit-input-placeholder{
            color: #fff;
          }
        }
        .search-button {
          background: url(../assets/img/search-icon.png) center center;
          background-repeat: no-repeat;
          width:36px;
          height: 40px;
          background-color: none;
          border: none;
          outline: none;
          cursor: pointer;
        }
        ul {
          position: absolute;
          left: 0;
          top: 100%;
          margin-top: 8px;
          width: 100%;
          // background: url(../assets/img/search-bg.png) -20px top;
          background: #fff;
          background-size: 120%;
          padding: 0;
          border-radius: 10px;
          overflow: hidden;
          li {
            padding: 0 10px;
            font-weight: normal;
            &:last-child {
              border-bottom: none;
            }
            a, a:link, a:visited, a:active {
              color: #666;
              display: block;
              text-decoration: none;
            }
            i, :deep(i) {
              font-style: normal;
              font-weight: bold;
              color: #333;
            }
            &.hover, &:hover {
              color: #fff;
              background: rgba($color: #f34277, $alpha: 1.0);
              a, a:link, a:visited, a:active {
                color: #fff;
                i, :deep(i) {
                  color: #fff;
                }
              }
            }
          }
        }
      }
      p {
        color: #fff;
        font-size: 12px;
        line-height: 22px;
        margin-top: 5px;
        max-width: 330px;
        a {
          display: inline-block;
          margin-left: 12px;
          color: #fff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 70px;
        }
      }
    }
    .fly-pic {
      float: right;
      background: url(../assets/img/fly.png);
      background-repeat: no-repeat;
      display: inline-block;
      width: 205px;
      min-height: 178px;
      margin-top: 5px;
    }
  }
  .nav-container {
    margin: 0 auto;
    background: #fff;
    border-radius: 8px;
    height: 83px;
    ul {
      display: flex;
      height: 82px;
      overflow: hidden;
      li {
        flex: 1;
        align-items: center;
        text-align: center;
        font-size:18px;
        border-radius: 34px;
        line-height: 84px;
        a {
          // flex: 1;
          // align-items: center;
          min-width: 60px;
          border-radius: 34px;
          line-height: 34px;
          display: inline-block;
          padding: 0 12px;
        }
        a.fire-icon {
          background: url(../assets/img/pic-fire.png);
          background-size: 30px!important;
          background-repeat: no-repeat;
          background-position: 0px 0!important;
          padding-left: 28px;
        }
        a:hover, a:active, a:visited {
          text-decoration: none;
        }
        a:hover {
          color: #FD3374;
        }
        &.active {
          & a {
            background: #FD3374;
            line-height: 34px;
            color:#fff;
          }
          & a.fire-icon {
            background: url(../assets/img/pic-fire.png) #FD3374;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
}
.search-container-l {
  min-height: 82px;
  .search-content {
      margin-top: 40px;
      position: relative;
      .search-box {
        background-repeat: no-repeat;
        width: 1002px;
        height: 42px;
        position: relative;
        z-index: 2;
        input {
          line-height: 42px;
          height: 42px;
          vertical-align: top;
          background: none;
          border: none;
          padding-left: 18px;
          color: #333;
          font-size: 14px;
          width: 100%;
          outline: none;
          background: #fff;
          border-radius: 42px;
          box-sizing: border-box;
          padding-right: 50px;
          &::-webkit-input-placeholder{
            color: #fff;
          }
        }
        .search-button {
          position: absolute;
          right: 12px;
          top: 1px;
          background: url(../assets/img/bg-search.png) center center;
          background-repeat: no-repeat;
          width:36px;
          height: 40px;
          background-color: none;
          border: none;
          outline: none;
          cursor: pointer;
        }
        ul {
          position: absolute;
          left: 0;
          top: 100%;
          margin-top: 4px;
          width: 100%;
          // background: url(../assets/img/search-bg.png) -20px top;
          background: #fff;
          background-size: 120%;
          padding: 0;
          border-radius: 10px;
          overflow: hidden;
          li {
            padding: 0 10px;
            font-weight: normal;
            &:last-child {
              border-bottom: none;
            }
            a, a:link, a:visited, a:active {
              color: #666;
              display: block;
              text-decoration: none;
            }
            i, :deep(i) {
              font-style: normal;
              font-weight: bold;
              color: #333;
            }
            &.hover, &:hover {
              color: #fff;
              background: rgba($color: #f34277, $alpha: 1.0);
              a, a:link, a:visited, a:active {
                color: #fff;
                i, :deep(i) {
                  color: #fff;
                }
              }
            }
          }
        }
      }
      p {
        color: #fff;
        font-size: 12px;
        line-height: 22px;
        margin-top: 5px;
        a {
          display: inline-block;
          margin-left: 22px;
          color: #fff;
        }
      }
    }
}
.search-box {
  min-height: auto;
}
</style>
